import React from "react";
import PatientListRow from "./PatientListRow";

const PatientList = (props) => {
  const { patients, addTab } = props;

  return (
    <div className="flex flex-col gap-[1.375rem] pt-[1.375rem] h-full max-h-[90%] overflow-auto box-border bg-[#111] ">
      {Array.isArray(patients) && patients.length > 0 ? (
        patients.map((patient) => (
          <PatientListRow
            patient={patient}
            key={patient.patientID ?? "not-unique"}
            handleClick = {(patientID) =>addTab('patient', patientID)}
          />
        ))
      ) : (
        <p className='text-white'>No patients found.</p>
      )}
    </div>
  );
};

export default PatientList;
